/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadPccPatientDetailsResponse
 */
export interface UploadPccPatientDetailsResponse {
    /**
     * 
     */
    patient_id: string;
}

/**
 * Check if a given object implements the UploadPccPatientDetailsResponse interface.
 */
export function instanceOfUploadPccPatientDetailsResponse(value: object): value is UploadPccPatientDetailsResponse {
    if (!('patient_id' in value) || value['patient_id'] === undefined) return false;
    return true;
}

export function UploadPccPatientDetailsResponseFromJSON(json: any): UploadPccPatientDetailsResponse {
    return UploadPccPatientDetailsResponseFromJSONTyped(json, false);
}

export function UploadPccPatientDetailsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadPccPatientDetailsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'patient_id': json['patient_id'],
    };
}

export function UploadPccPatientDetailsResponseToJSON(json: any): UploadPccPatientDetailsResponse {
    return UploadPccPatientDetailsResponseToJSONTyped(json, false);
}

export function UploadPccPatientDetailsResponseToJSONTyped(value?: UploadPccPatientDetailsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patient_id': value['patient_id'],
    };
}

